import cx from "classnames";
import Image from "next/image";
const ProductBottomBanner = ({
  bottomDesktopBanners,
  bottomMobileBanners,
  productName
}) => {
  if (bottomDesktopBanners?.length === 0 && bottomMobileBanners?.length === 0) return;
  return <div className="w-full pb-4" data-sentry-component="ProductBottomBanner" data-sentry-source-file="ProductBottomBanner.jsx">
      {bottomDesktopBanners?.map(banner => <>
          <Image src={banner?.imageURI} key={banner?.id} width={banner?.width} height={banner?.height} className={cx("mx-auto", {
        "hidden sm:block": banner?.imageType === "BOTTOM_DESKTOP"
      })} alt={productName} />
        </>)}
      {bottomMobileBanners?.map(banner => <>
          <Image src={banner?.imageURI} width={banner?.width} height={banner?.height} className={cx("mx-auto", {
        "sm:hidden": banner?.imageType === "BOTTOM_MOBILE"
      })} key={banner?.id} alt={productName} />
        </>)}
    </div>;
};
export default ProductBottomBanner;